import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../api/base";
import { useAuth } from "../context/AuthContext";

export default function CreateUser() {
  const navigate = useNavigate();
  const { token } = useAuth();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("technician");

  const isSuperAdmin = localStorage.getItem("is_super_admin") === "true";

  // Guard: only super admins can access
  useEffect(() => {
    if (!token || !isSuperAdmin) {
      navigate("/");
    }
  }, [token, isSuperAdmin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      full_name: fullName,
      email,
      password,
      role: role.toLowerCase(),
    };

    try {
      const response = await fetch(`${API_BASE}/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.status === 403) {
        alert("You are not allowed to create users.");
        return;
      }

      if (!response.ok) {
        alert(data.detail || "Create failed");
        return;
      }

      alert("User created!");
      navigate("/users");
    } catch (error) {
      console.error("Error creating user", error);
      alert("Could not create user.");
    }
  };

  return (
    <div style={{ maxWidth: "500px", margin: "30px auto", padding: "20px" }}>
      <h1 style={{ marginBottom: "20px" }}>Create User</h1>
      <p style={{ color: "#555", marginBottom: "14px" }}>
        Only super admins can add users.
      </p>

      <form onSubmit={handleSubmit}>
        <label style={labelStyle}>Full Name</label>
        <input
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          style={inputStyle}
          placeholder="Full name"
        />

        <label style={labelStyle}>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
          placeholder="user@example.com"
        />

        <label style={labelStyle}>Role</label>
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          style={inputStyle}
        >
          <option value="technician">Technician</option>
          <option value="host">Host</option>
          <option value="admin">Admin</option>
        </select>

        <label style={labelStyle}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />

        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button type="submit" style={btnPrimary}>
            Create User
          </button>
          <button
            type="button"
            onClick={() => navigate("/users")}
            style={btnSecondary}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

const labelStyle = {
  display: "block",
  marginBottom: "6px",
  fontWeight: "bold",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const btnPrimary = {
  padding: "10px 16px",
  background: "#3498db",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const btnSecondary = {
  padding: "10px 16px",
  background: "#bdc3c7",
  color: "#2c3e50",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};
